export const getTokenScope = (state) => {
  return state.tokenScope;
};
